
const isFunction = input => typeof input === 'function';
const renderIf = predicate => elemOrThunk =>
    predicate ? (isFunction(elemOrThunk) ? elemOrThunk() : elemOrThunk) : null;

const utcStringToLocalDate = (utcString, format) => {
    const date = new Date(utcString + 'Z');
    format = format || 'YYYY-MM-DD';
    return date.toLocaleDateString();
}

const utcStringToLocalDateTime = (utcString, format) => {
    utcString = utcString
    const date = new Date(utcString + 'Z');
    return date.toLocaleDateString() + ' ' +  date.toLocaleTimeString();
}

export { 
    renderIf,
    utcStringToLocalDate,
    utcStringToLocalDateTime
}


// WEBPACK FOOTER //
// ./src/common/utility.js